// removed by extract-text-webpack-plugin
module.exports = {"icon":"new-pdp__icon__cdb9a3a7","title":"new-pdp__title__cdb9a3a7","info":"new-pdp__info__cdb9a3a7","link":"new-pdp__link__cdb9a3a7","promo":"new-pdp__promo__cdb9a3a7","quote":"new-pdp__quote__cdb9a3a7"};


//////////////////
// WEBPACK FOOTER
// ./assets/scss/new-pdp/new-pdp.scss
// module id = 3521
// module chunks = 4